<template>
    <div class="container static-page-tabs">
        <div class="tabs-container">
            <div class="tab-item" :key="tab.id" v-for="tab in data" :class="{'active': selectedId === tab.id}" @click="select(tab.id)">
                {{tab.title}}
            </div>
        </div>
        <div class="tabs-content" v-if="isSelected">
            <div class="animate-div" v-html="data.filter(r => r.id === selectedId)[0].description" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "static-page-tabs",
        props: ["data"],
        data(){
            return {
                selectedId: this.data.length ? this.data[0].id : null,
            }
        },
        computed: {
              isSelected() {
                  return  this.data.filter(r => r.id === this.selectedId).length;
              }
        },
        methods: {
            select(id) {
                this.selectedId = null;
                setTimeout(() => {
                    this.selectedId = id;
                },1)
            }
        },
    }
</script>

<style scoped>

    .static-page-tabs {
        display: flex;
        padding-top: 50px;
        position: relative;
    }
    .tab-item {
        cursor: pointer;
        background-color: #EBEBEB;
        width: 220px;
        text-align: left;
        border: 1px solid #e3e3e3;
        color: #666;
        padding: 12px 20px;
        border-radius: 5px;
        font-size: 13px;
        margin-bottom: 2px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .tab-item.active {
        border-color: #e3e3e3;
        background-color: #f8f8f8;
        border-right-color: transparent;
        border-right: unset;
    }

    .tab-item.active:hover {
        background-color: #f8f8f8;
    }

    .tab-item:hover {
        transition: .3s ease;
        background-color: #cbcbcb;
    }

    .tabs-content {
        border: 1px solid #e3e3e3;
        border-left: unset;
        border-radius: 5px;
        border-top-left-radius: 0;
        background-color: #f8f8f8;
        text-align: left;
        font-size: 16px;
        padding: 0 20px 14px;
    }

    .animate-div {
        animation-name: bounce-show;
        animation-fill-mode: forwards;
        animation-duration: .5s;
    }

    .tabs-content div {
        transition: .5s ease;
    }

    .show-content {
        animation-name: bounce-show;
        animation-fill-mode: forwards;
        animation-duration: .3s;

    }

    @keyframes bounce-show {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
</style>

<style>
    .tabs-content div p {
        padding: 1em 0;
        color: #666;
        line-height: 150%
    }
</style>